import { jsPDF } from 'jspdf';
import QRCode from 'qrcode';

const img = (src) => fetch(src).then((r) => r.blob()).then((b) => new Promise((res) => { const f = new FileReader(); f.onload = () => res(f.result); f.readAsDataURL(b); }));

function card(d, x, y, w, h, { t, qr, logo, contact, feats }) {
  d.setFillColor(15, 23, 42); d.rect(x, y, w, 34, 'F');
  d.setFillColor(249, 115, 22); d.rect(x, y + 34, w, 1.6, 'F');
  d.addImage(logo, 'PNG', x + 7, y + 7, 20, 20);
  d.setTextColor(255); d.setFont('helvetica', 'bold'); d.setFontSize(14.5); d.text('GISS FieldRapport Pro', x + 31, y + 16);
  d.setFont('helvetica', 'normal'); d.setFontSize(8.2); d.setTextColor(253, 224, 71);
  d.text(d.splitTextToSize(t.pcTag, w - 38), x + 31, y + 22);
  let yy = y + 46;
  (feats || [t.pcF1, t.pcF2, t.pcF3]).forEach((f) => {
    d.setFillColor(22, 163, 74); d.circle(x + 10, yy - 1.3, 2.3, 'F');
    d.setDrawColor(255); d.setLineWidth(0.6); d.line(x + 8.9, yy - 1.3, x + 9.8, yy - 0.3); d.line(x + 9.8, yy - 0.3, x + 11.3, yy - 2.4);
    const [head, ...rest] = f.split(' – ');
    d.setTextColor(15, 23, 42); d.setFont('helvetica', 'bold'); d.setFontSize(9.6); d.text(head, x + 15, yy);
    d.setFont('helvetica', 'normal'); d.setFontSize(8); d.setTextColor(71, 85, 105);
    const l = d.splitTextToSize(rest.join(' – '), w - 22); d.text(l, x + 15, yy + 4.3);
    yy += 9 + l.length * 3.6;
  });
  const qy = y + h - 50;
  d.addImage(qr, 'PNG', x + 7, qy, 38, 38);
  d.setTextColor(15, 23, 42); d.setFont('helvetica', 'bold'); d.setFontSize(12); d.text(d.splitTextToSize(t.playTrial7, w - 56), x + 50, qy + 8);
  d.setFont('helvetica', 'normal'); d.setFontSize(8); d.setTextColor(71, 85, 105); d.text(d.splitTextToSize(t.pcScan, w - 56), x + 50, qy + 19);
  d.setFillColor(15, 23, 42); d.roundedRect(x + 50, qy + 27, w - 57, 9, 2, 2, 'F');
  d.setTextColor(255); d.setFont('helvetica', 'bold'); d.setFontSize(8.5); d.text('Google Play', x + 50 + (w - 57) / 2, qy + 32.8, { align: 'center' });
  if (contact) { d.setFont('helvetica', 'normal'); d.setFontSize(7); d.setTextColor(100, 116, 139); d.text(contact, x + w / 2, y + h - 5, { align: 'center', maxWidth: w - 10 }); }
}

// A4 sheet with 4 A6 promo cards + cut marks
export async function promoCardPdf({ t, url, contact, feats }) {
  const [qr, logo] = await Promise.all([QRCode.toDataURL(url, { width: 600, margin: 1 }), img('/icon-192.png')]);
  const d = new jsPDF({ unit: 'mm', format: 'a4' });
  const w = 105, h = 148.5;
  [[0, 0], [w, 0], [0, h], [w, h]].forEach(([x, y]) => card(d, x, y, w, h, { t, qr, logo, contact, feats }));
  d.setDrawColor(160); d.setLineWidth(0.2); d.setLineDashPattern([1.5, 1.5], 0);
  d.line(w, 0, w, 297); d.line(0, h, 210, h);
  d.save('GISS-FieldRapport-Werbekarte.pdf');
}
